module.exports = __webpack_public_path__ + "img/product_5.332a3d9.jpg";